import { lazyNamed } from 'src/utils/lazyNamed.ts';

// The admin surface for the ZZupport chat: the list of every conversation, and the one
// conversation an admin opens from it.
const SupportChat = {
  SupportChatList: lazyNamed(() => import('./containers/SupportChatList/index.tsx'), 'SupportChatList'),
  SupportChatConversation: lazyNamed(() => import('./containers/SupportChatConversation/index.tsx'), 'SupportChatConversation'),
};

export default SupportChat;
